var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.626 3.00008C13.3789 3.05417 16.4579 6.48248 18 9.43226C18 9.43226 17.4573 10.5606 16.9484 11.2829C16.7021 11.6323 16.443 11.9727 16.1707 12.302C15.9766 12.5364 15.7761 12.7646 15.5681 12.9864C13.7094 14.9698 11.04 16.4493 8.22122 15.8749C5.08975 15.2366 2.53539 12.5104 1 9.57831C1 9.57831 1.54516 8.44888 2.05695 7.72766C2.28623 7.4042 2.52687 7.08939 2.77886 6.78395C2.97194 6.54991 3.17212 6.32165 3.37903 6.09987C5.02125 4.34155 7.12842 2.98782 9.626 3.00008ZM9.61287 4.44252C7.52238 4.43458 5.78398 5.62063 4.40866 7.09299C4.22162 7.29313 4.04132 7.4994 3.8667 7.71071C3.63706 7.9891 3.41772 8.27651 3.20867 8.57113C2.99962 8.86538 2.78525 9.23681 2.61525 9.55234C3.96891 11.8635 6.00083 13.951 8.50054 14.4606C10.8299 14.9355 13.0038 13.6308 14.5399 11.9919C14.7276 11.7917 14.909 11.5851 15.0843 11.3734C15.3328 11.073 15.5691 10.7625 15.7938 10.4434C16.0018 10.1481 16.2158 9.77592 16.3855 9.46003C14.9807 7.07099 12.5772 4.4894 9.61287 4.44252Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.50019 6.61328C11.0707 6.61328 12.3459 7.90895 12.3459 9.50428C12.3459 11.1 11.0707 12.3953 9.50019 12.3953C7.93002 12.3953 6.65479 11.1 6.65479 9.50428C6.65479 7.90895 7.93002 6.61328 9.50019 6.61328Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.ddfe13b422703212d5a852386bb589eb.svg";
export { ForwardRef as ReactComponent };